import {BifrostBackendApi} from "../gateways/BifrostBackendApi";

const generateHeaders = (jwtToken) =>
	({
		Authorization: jwtToken
	});

const OrdersProvider = {
	generateOrders(data, jwtToken) {
		return BifrostBackendApi
			.post(`/orders-generate`, data, { headers: generateHeaders(jwtToken) })
			.then(response => response.data);
	}
};

export default Object.freeze(OrdersProvider);
